import { apiFetch } from './utils/api';
// const mockedNetwork = require('./mocks/v1/wealth-plan/network.json');

export const network = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v1/wealth-plan/network';

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
